import { Banner } from "./Banner";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { SendResume } from "./SendResume";
import { SideNav } from "./SideNav";

export const Layout = ({
  title = "waiting for you in our team",
  action = "Send resume",
  link = "https://devsterlabs.com/apply",
  hint = "Leave your CV and our manager will contact you soon",
  children,
}) => {
  return (
    <>
      <div className="bg"></div>
      <SideNav />
      <Header />
      {children}
      <Banner />
      <SendResume title={title} action={action} link={link} hint={hint} />
      <Footer />
    </>
  );
};
